import React, { useEffect, useState } from "react";
import { MediaImage } from "@app/scripts/react-general-components/MediaImage";
import { GET_PRODUCTS_BY_ID } from "@app/scripts/utils/queries";
import type { GQLProduct, NormalisedProduct } from "@app/scripts/types";
import { shopify } from "@app/scripts/utils/graphql";
import { useShopify } from "@app/scripts/react-hooks/shopify";
import { formatPrice } from "@app/scripts/utils";

type CartGwpPlaceholderProps = {
    productIds: (string | number)[];
    untilGiftThreshold: {
        amount: number;
        currency: string;
    };
};

export const CartGwpPlaceholder: React.FC<CartGwpPlaceholderProps> = ({ productIds, untilGiftThreshold }) => {
    const [products, setProducts] = useState<NormalisedProduct[]>([]);
    const { normaliseProduct } = useShopify();

    function extractColorName(input: any) {
        const parts = input?.split('--');
        const formattedColors = [];

        parts.forEach(part => {
            const colorNames = part?.split('-');
            const formattedNames = colorNames.map(name => name?.charAt(0)?.toUpperCase() + name?.slice(1)?.toLowerCase());
            formattedColors.push(formattedNames.join(' '));
        });

        return formattedColors[1];
    }

    function handleProductColour(productTags: any) {
        // Finds tag with colour string
        let colorString = productTags?.filter(tag => tag?.includes("color--"));

        if (colorString.length == 0) return "";
        // Extracts colour name from tag
        colorString = extractColorName(colorString[0])
        return colorString;
    }

    useEffect(() => {
        const getProducts = async () => {
            if (productIds.length) {
                const data = await shopify(GET_PRODUCTS_BY_ID, {
                    ids: productIds.map((product) => `gid://shopify/Product/${product}`),
                });

                if (data?.nodes) {
                    const filtered = data.nodes
                        ?.filter(
                            (product: GQLProduct) => product?.handle && !window.location.pathname.includes(`/${product.handle}`)
                        )
                        ?.map((product: GQLProduct) => normaliseProduct(product));

                    if (filtered?.length) {
                        setProducts(filtered);
                    }
                }
            }
        };
        getProducts();
    }, []);

    let color = products[0]?.tags ? handleProductColour(products[0]?.tags) : ""

    const untilGiftThresholdString = formatPrice(untilGiftThreshold?.amount, untilGiftThreshold?.currency);

    return (
        <div className="cart__line-item-wrapper">
            <div className={`cart__line-item`} >
                {products[0]?.featured_image ?
                    < a href={products[0]?.url} title={products[0]?.title} className="block">
                        <MediaImage media={products[0]?.featured_image} />
                    </a> : null}
                <div className="cart__line-item__content">
                    <div className="cart__line-item__content-details">
                        <div>
                            <h3 className="mb-2">
                                <a href={products[0]?.url} title={products[0]?.title} className="cart__line-item__title text-md bold">
                                    {products[0]?.title}
                                </a>
                            </h3>

                            {color ? <div className="text-sm text-secondary-grey caps">{color}</div> : null}
                        </div>
                        {/* <div className="flex">
                            <div className="text-md cart__line-item__gift-free mr-2 bold">FREE</div>
                            <div className="text-md bold line-through">{products[0]?.price}</div>
                        </div> */}
                    </div>
                    <div className="cart__line-item__gift-message-underachieved text-sm mt-5">
                        {productIds.length > 1 ?
                            <>You are <span className="bold">{untilGiftThresholdString}</span> away from receiving a free gift</>
                            :
                            <>You are <span className="bold">{untilGiftThresholdString}</span> away from receiving your free gift</>
                        }
                    </div>
                </div>
            </div>
        </div >
    );
};
